<template>
    <div>
      <h2>홈화면의 오늘수업 / 보강</h2>
      <p>
        다른 학원관리시스템과 차별화된 Tens에듀만의 <span class="bg-yellow-13">강력한 장점</span>으로는 <span class="bg-light-green-13">홈화면에서의 오늘수업/보강</span>입니다. <br/>
        이는 오늘 수업에 대한 정보와 함께 출결관리를 할 수 있습니다.
      </p>
      
      <section>
        <div class="p-relative section_0" id="today">
            <div class="ft-b">1)  오늘수업 / 보강</div>
        
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today.jpg" /></div>
            </div>
            <p></p>
            <div class="p-relative section_1">
                -   “출결”버튼을 클릭하여 학생의 출결정보와 등하원메시지를 부모님께 발송할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today_attendance.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   오늘에서 발송하는 등하원메시지는 선생님이 직접 발송하는 경우이고, Qr코드로 학생이 발송하도록 할 수도 있습니다.
            </div>
            <p></p>
            <div class="p-relative section_1">
                -   학생이 결석하는 경우는 “결석”버튼을 클릭하여 출결상태를 저장하고,
            </div>
            <div class="p-relative section_1">
                -   “대기>보강생성”버튼을 클릭하여 보강을 생성할 수 있습니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today_reclass.jpg" /></div>
            </div>
            <p></p>

            <div class="p-relative section_1">
                -   보강이 설정되면 보강 날짜가 되면 홈화면의 오늘보강에 다음과 같이 보강리스트가 나타납니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today_reclass_list.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="today_create_class">
            <div class="ft-b">2)  오늘 수업의 자동(수동) 생성</div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   오늘 수업은 당일 새벽 2시에 자동으로 생성됩니다.
            </div>
            <div class="p-relative section_1">
                -   경우에 따라 수업은 요일이 변경될 수 있습니다. 따라서, 미리 생성되지 않고 당일의 새벽에 자동 생성합니다.
            </div>
            <div class="p-relative section_1">
                -   오늘 수업이 생성되면, 출결정보, 숙제, 시험결과, 진도처리 등의 수업에서 일어나는 각종 정보를 저장할 수 있습니다
            </div>
            <div class="p-relative section_1">
                -   만약, 새벽에 생성되었지만 날짜 또는 시간이 변경되어는 경우는 이전에 잘못 생성된 오늘 수업정보를 삭제하고 다시 생성할 수 있습니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/home/today_make_class.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   만약, 미래의 날짜의 수업정보를 미리 생성하는 경우는 생성하기 원하는 날짜를 맞추고 “수업수동생성” 버튼을 클릭하여 생성합니다.
            </div>
            <div class="p-relative section_2">
                당일 자동 생성시에 그 날짜의 수업정보가 미리 생성되어 있다면, 그 수업은 또 생성하지 않습니다.
            </div>

        </div>
        


      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '오늘 수업', link: '#today' },
                { label: '오늘 수업의 자동(수동) 생성', link: '#today_create_class' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


